import React from "react";

const ColumnFlex = (props) => {
    return <div className={`flex flex-col h-full m-0 ${props.className || ""}`}>{props.children}</div>;
};

export default ColumnFlex;
